module.exports = __webpack_public_path__ + "static/media/bluejays-ringer-mb-fr.258b5699.jpg";